import {updateCounts} from 'api/reports/util/ImageUtils';

export const getPropertiesPhotoCount = (comparables, counts) => {
  Object.values(comparables.properties).forEach((p) => {
    if (comparables.selected.includes(p.propertyId)) {
      if (comparables.featured.includes(p.propertyId) && p.featuredPhotos && p.featuredPhotos.length > 0) {
        p.featuredPhotos.forEach((featuredPhotoUri) => {
          if (featuredPhotoUri) {
            updateCounts(counts, featuredPhotoUri, p.uploadPhotoList);
          }
        });
      } else {
        if (p.propertyPhotoUriSelectedIndex || p.propertyPhotoUriSelectedIndex >= 0) {
          if (p.propertyPhotoList) {
            const photoUrl = p.propertyPhotoList[p.propertyPhotoUriSelectedIndex];
            if (photoUrl) {
              updateCounts(counts, photoUrl, p.uploadPhotoList);
            }
          }
        } else {
          if (p.propertyPhotoList && p.propertyPhotoList.length > 0) {
            counts.existing++;
          }
        }
      }
    }
  });
};
